export const formatoMarkdown = (propuestas) => {    
        const formatValue = (value) => {
            if (typeof value === 'string') {
                // Si es una cadena, se devuelve tal cual.
                return value;
            } else if (Array.isArray(value)) {
                // Si es una lista, se formatea cada elemento.
                return value.map(v => `* ${v}`).join('\n');
            } else if (typeof value === 'object') {
                // Si es un objeto, se convierte a JSON y luego se muestra.
                return '```\n' + JSON.stringify(value, null, 2) + '\n```';
            }
            return String(value);
        };

        return Object.entries(propuestas)
            .map(([_, value]) => formatValue(value))
            .join('\n\n');    
}
